export enum FileLineEnd {
	CRLF = 0,
	LF = 1,
}
